import { render, staticRenderFns } from "./RecommendHotelCard.vue?vue&type=template&id=5cde0428&"
import script from "./RecommendHotelCard.vue?vue&type=script&lang=js&"
export * from "./RecommendHotelCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports